import React, { useState, useEffect, useContext, useRef } from 'react';
import OneColumn from '../../layout/containers/OneColumn';
import { Grid, Row } from 'react-flexbox-grid';
import ExpedientsSearcher from '../expedient_searcher/ExpedientsSearcher';
import { Table } from '../../helpers_components/remote_pagination/Table';
import {
  columns,
  getExpedientsList,
  getSearchOfExpedients,
  rowClasses,
} from './expedients_list_logic';
import LoaderContext from '../../layout/shared/loader_context';
import { Tabs, Tab } from 'react-bootstrap';
import { useMemo } from 'react';
import { set } from 'lodash';
const pageConfig = {
  active: 'my_expedients',
  title: 'Mis expedientes',
};

const pageDefaultValue = 1;

const ExpedientsList = (props) => {
  const [key, setKey] = useState('expedients');
  const [cleaning, setCleaning] = useState(false);
  const [searching, setSearching] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [page, setPage] = useState(pageDefaultValue);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const loader = useContext(LoaderContext);
  const previousSearchValue = useRef('');
  const isArchived = useMemo(() => key === 'archived', [key]);

  useEffect(() => {
    (async function () {
      await getExpedientsList(sizePerPage, page, setData, setTotal, isArchived);
    })();
  }, []);
  const searchExpedients = async (_page = page, _sizePerPage = sizePerPage) => {
    if (previousSearchValue.current !== search) {
      previousSearchValue.current = search;
      _page = pageDefaultValue;
      setPage(pageDefaultValue);
    }
    if (search.length > 0 && /^$|.*\S+.*/.test(search)) {
      setSearching(true);
      loader.show(true);
      let searchValue = search.trim().replace(/\//g, '-').replace(/-/g, '@');

      await getSearchOfExpedients(searchValue, _sizePerPage, _page, setData, setTotal, isArchived);

      setSearching(false);
      loader.show(false);
    } else {
      cleanSearch();
    }
  };

  const cleanSearch = async () => {
    setSearch('');
    setPage(pageDefaultValue);
    setCleaning(true);
    loader.show(true);
    await getExpedientsList(sizePerPage, pageDefaultValue, setData, setTotal, key === 'archived');

    setCleaning(false);
    loader.show(false);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setSizePerPage(sizePerPage);
    setPage(page);

    if (search) {
      return searchExpedients(page, sizePerPage);
    }

    await getExpedientsList(sizePerPage, page, setData, setTotal, key === 'archived');
  };

  const handleTabSelect = (k) => {
    setKey(k);
    setPage(pageDefaultValue);
    setData([]);
    setTotal(0);
    const newIsArchived = k === 'archived';
    if (search) {
      getSearchOfExpedients(
        search.trim().replace(/\//g, '-').replace(/-/g, '@'),
        sizePerPage,
        pageDefaultValue,
        setData,
        setTotal,
        newIsArchived
      );
    } else {
      getExpedientsList(sizePerPage, pageDefaultValue, setData, setTotal, k === 'archived');
    }
  };

  return (
    <OneColumn {...props} pageConfig={pageConfig}>
      <Grid style={{ minHeight: '62vh' }}>
        <Row>
          <ExpedientsSearcher
            leyend={'Mis expedientes'}
            placeholderSearch="Palabra o término a buscar"
            placeholderSearchButton="Buscar"
            placeholderCleanButton="Limpiar"
            helperContextual='Escribe el término deseado y oprime el botón "Buscar"'
            executeSearch={searchExpedients}
            cleanSearch={cleanSearch}
            isSearching={searching}
            isCleaning={cleaning}
            setSearch={setSearch}
            search={search}
            classNameButtonsSearch={'buttonsSearchExpedientsList'}
            hasRulesToSearch={false}
            rulesToSearch={/^[a-zA-Z0-9/]*$/}
          />
        </Row>

        <Row>
          <Grid fluid={true}>
            <section className="procedures-table-container mT-30">
              <Tabs
                id="expedients-tabs"
                activeKey={key}
                onSelect={handleTabSelect}
                className="mb-3"
              >
                <Tab eventKey={'expedients'} title="Expedientes">
                  <Table
                    data={data}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={total}
                    onTableChange={handleTableChange}
                    rowClasses={rowClasses}
                    columns={columns(
                      search.length > 0,
                      async () =>
                        await getExpedientsList(sizePerPage, page, setData, setTotal, isArchived),
                      async () => {
                        await getSearchOfExpedients(
                          search.trim().replace(/\//g, '-').replace(/-/g, '@'),
                          sizePerPage,
                          page,
                          setData,
                          setTotal,
                          isArchived
                        );
                      }
                    )}
                  />
                </Tab>
                <Tab eventKey={'archived'} title="Archivados">
                  <Table
                    data={data}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={total}
                    onTableChange={handleTableChange}
                    rowClasses={rowClasses}
                    columns={columns(
                      search.length > 0,
                      async () =>
                        await getExpedientsList(sizePerPage, page, setData, setTotal, isArchived),
                      async () => {
                        await getSearchOfExpedients(
                          search.trim().replace(/\//g, '-').replace(/-/g, '@'),
                          sizePerPage,
                          page,
                          setData,
                          setTotal,
                          isArchived
                        );
                      }
                    )}
                  />
                </Tab>
              </Tabs>
            </section>
          </Grid>
        </Row>
      </Grid>
    </OneColumn>
  );
};

export default ExpedientsList;
